import { useEffect } from 'react';
import page404 from '../../shared/assets/images/404.png';

interface NotFoundProps {
  isAtWork?: boolean;
  isError?: boolean;
}

const NotFound = ({ isAtWork = false, isError = false }: NotFoundProps) => {
  useEffect(() => {
    document.title = 'Страница не найдена';
  }, []);

  return (
    <div>
      <h1 className="text-center mt-[30px] text-[64px] font-extrabold text-[#20242e] leading-[78px]">
        {isAtWork && 'Страница находится в разработке'}
        {!isError && !isAtWork && 'Уппс...'}
        {isError && 'Уппс...'}
      </h1>
      <h2 className="text-center mt-2 text-2xl font-bold text-[#20242e] leading-[29px]">
        {isAtWork ? '' : 'Страница не найдена'}
        {isError ? 'Возникла ошибка' : ''}
      </h2>
      <div className="text-center mx-auto my-[37px] text-lg font-medium text-[#20242e] leading-[140%] w-[394px]">
        {isAtWork && 'Вкладка находится в разработке, будет добавлена в ближайшее время'}
        {!isError && !isAtWork && 'Возможно, был введен неверный адрес, либо страница была перемещена'}
        {isError && 'Возникла ошибка при загрузке страницы'}
      </div>
      <img src={page404} alt="Не найдено" className="my-[70px] mx-auto block h-[410px] w-[664px]" />
      <button
        className="mx-auto w-[252px] h-[50px] rounded-[10px] bg-[#e3282a] text-white text-lg border-0 font-semibold cursor-pointer block"
        onClick={() => (window.location.href = '/')}
      >
        Вернуться на главную
      </button>
    </div>
  );
};

export default NotFound;
